import { render, staticRenderFns } from "./CookiesDisclaimer.vue?vue&type=template&id=6ab1fa55&lang=html&"
import script from "./CookiesDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./CookiesDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./CookiesDisclaimer.vue?vue&type=style&index=0&id=6ab1fa55&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports